import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import EmptySearch from '@/components/core/InputSearch/Empty';

export default function GameSearchModalEmptySearch() {
  const search = useSelector((state: RootState) => state.casino.modalSearch);

  return (
    <div className={styles.container}>
      <EmptySearch search={search} />
    </div>
  );
}
